<template>
  <div class="content-wrapper summary-buttonset mt-5">
    <div class="d-flex justify-content-around buttons-line">
      <button class="btn" v-on:click="backToConfigurator" id="btn-edit">
        Edit <span class="hide-xs">configuration</span>
      </button>
      <!-- <button id="btn-save-configuration" class="btn" v-on:click="saveConfiguration">
        Save <span class="hide-xs">configuration</span>
      </button> -->
      <button
        id="btn-download-configuration"
        class="btn"
        v-on:click="downloadConfiguration"
      >
        Download Pdf
      </button>

      <button
        id="btn-configure-another"
        class="btn"
        v-on:click="configureAnother"
      >
        Configure another
      </button>
    </div>
    <div class="mt-4">
      <!-- <button id="btn-confirm-configuration" class="btn btn-outline-primary" v-on:click="confirmConfiguration">
        Confirm configuration
      </button> -->
      <button
        id="btn-confirm-configuration"
        class="btn btn-outline-primary"
        v-on:click="saveConfiguration"
      >
        Confirm configuration
      </button>

      <button
        id="btn-ask-information"
        class="btn btn-outline-primary"
        v-on:click="askInformation"
      >
        Ask for information
      </button>
    </div>

    <div id="admin-section" v-if="isAdmin">
      <h5>ADMIN SECTION</h5>
      <div class="d-flex justify-content-center align-items-baseline">
        <button
          class="btn btn-outline-primary"
          v-on:click="saveConfigurationAsDefault"
        >
          Save configuration as default
        </button>
        <div class="form-group slot-wrapper">
          <label for="configuration_slot">
            in the <strong>slot</strong> number
          </label>
          <select
            class="form configuration_slot"
            name="configuration_slot"
            id="configuration_slot"
          >
            <option value="1">#1</option>
            <option value="2">#2</option>
            <option value="3">#3</option>
          </select>
        </div>
        <div class="form-group name-wrapper">
          <label for="configuration_name"> with name </label>
          <input
            class="form configuration_name"
            name="configuration_name"
            id="configuration_name"
          />
        </div>
      </div>
    </div>

    <!-- <div class="round-button-wrapper no-print">
      <button
        class="btn btn-round"
        v-on:click="backToConfigurator"
      >
        <img width="30" src="/configurator/go-back-icon.png" />
        <div>Back to<br />configurator</div>
      </button>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "summary-buttonset",
  data() {
    return {};
  },
  props: ["loggedUser", "isAdmin"],
  methods: {
    saveConfiguration: function () {
      this.$emit("save-configuration");
    },
    askInformation: function () {
      this.$emit("ask-information");
    },
    downloadConfiguration: function () {
      this.$emit("download-configuration");
    },
    confirmConfiguration: function () {
      this.$emit("confirm-configuration");
    },
    backToConfigurator: function () {
      this.$emit("back-to-configurator");
    },
    configureAnother: function () {
      this.$emit("configure-another-bike");
    },

    saveConfigurationAsDefault: function () {
      const n = document.getElementById("configuration_slot").value;
      const name = document.getElementById("configuration_name").value;
      this.$emit("save-configuration-as-default", n + "#" + name);
    },
  },
};
</script>

<style lang="scss" scoped>
.summary-buttonset {
  .buttons-line {
    button {
      width: 30%;
    }
  }
}

#admin-section {
  border: 1px solid red;
  padding: 20px;
  margin: 20px 0;

  h5 {
    border-bottom: 1px solid black;
    margin-bottom: 20px;
  }
}

#btn-confirm-configuration,
#btn-edit,
#btn-download-configuration,
#btn-configure-another {
  @media (max-width: 767px) {
    width: 100%;
  }
}

#btn-ask-information {
  margin-left: 30px;
  @media (max-width: 767px) {
    width: 100%;
    margin-left: 0;
    margin-top: 30px;
  }
}

#configuration_name {
  margin-left: 10px;
  padding: 10px;
  border: 1px solid #000;
}

#configuration_slot {
  margin-left: 10px;
  margin-right: 10px;
}

.slot-wrapper {
  margin-left: 15px;
}

.summary-buttonset {
  max-width: 760px;
  margin: auto;

  button {
    font-size: 10px;
  }
}

.round-button-wrapper {
  position: absolute;
  top: -20px;
  left: 0;

  .btn-round {
    padding: 0;
    width: 120px;
    height: 120px;

    &:hover {
      text-decoration: underline;
    }

    img {
      margin-top: -20px;
    }
  }
}
</style>
